import { Component } from "@angular/core";
import { ScrollTopOptions } from "../../../../directives/home/scroll-top.directive";
import { LayoutConfigModel } from "../../../../interfaces/home/layout-config";

import * as objectPath from "object-path";

@Component({
  selector: "scroll-top",
  templateUrl: "./scroll-top.component.html",
  styleUrls: ["./scroll-top.component.css"]
})
export class ScrollTopComponent {
  // Public properties
  config: LayoutConfigModel;
  displaySroll: boolean;
  scrollTopOptions: ScrollTopOptions = {
    offset: 50,
    speed: 600
  };

  ngOnInit() {
    const config = JSON.parse(localStorage.getItem("layoutConfig"));

    // footer width fluid
    this.displaySroll = objectPath.get(config, "scroll.display");
  }
}
